<template>
  <div class="content">
    <div class="head-div" v-if="['/resource', '/repair', '/reslink'].indexOf($route.path)==-1">
      <Header></Header>
    </div>
    <div id="main-div">
      <router-view/>
    </div>
    <div v-if="['/resource', '/repair', '/reslink'].indexOf($route.path)==-1">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Header from './components/Header'
  import Footer from './components/Footer'

  export default {
    data() {
      return {
        situation: true,
        no_url: ['/login', '/register', '/retrieve', '/resetpwd']
      }
    },
    created() {
      this.$router.status = false;
      this.Judge_state();
    },
    methods: {
      // 判断状态
      async Judge_state() {
        if (localStorage.getItem('login_info')) {
          await this.$http.getVerify().then(response => {
            // 当token无效时
            if (response.code !== 200) {
              // this.$message.error('登录信息失效，请重新登陆！')
              localStorage.removeItem('login_info')
              localStorage.removeItem('user_info')
              this.$router.push({path: '/login'})
              this.$http.getLogout().then(resp=>{})
              // 当token存在时
            } else {
              this.$router.status = true;
              sessionStorage.setItem("login_info", localStorage.getItem('login_info'))
              sessionStorage.setItem("user_info", localStorage.getItem('user_info'))
              if (this.situation) {
                this.situation = false;
                this.bus.$emit('change', true);
              }
              // 当从浏览器直接输入下列地址时
              if (this.no_url.indexOf(
                this.$route.path) !== -1) {
                
                this.$router.push({path: '/main'})
              }
            }
          }).catch(err => {
            this.$message.error('获取失败');
            this.$router.push({path: '/login'})
          })
          // 当本地不存在token时直接跳转到此页面
        } else {
          if (this.no_url.indexOf(
            this.$route.path) === -1) {
            this.$router.status = false;
            this.$router.push({path: '/login'})
            this.$message({
              message: '请登录后再试',
              type: 'warning',
              customClass: 'hint-message',
              center: true
            });
          }
        }
      },
    },
    components: {
      Header,
      Footer
    },
    watch: {
      // 当页面路由跳转时则检查当前用户权限
      $route(to, from) {
        this.Judge_state()
      }
    }
  }
</script>

<style>
  html,
  body,
  div,
  span,
  p,
  a,
  em,
  img,
  small,
  strike,
  strong,
  b,
  u,
  i,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section,
  summary,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section {
    display: block;
  }

  input,
  button {
    border: none;
    outline: none;
  }

  *[hidden] {
    display: none;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: "";
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  html,
  body {
    height: 100%;
    width: 100%;
    font-size: 12px;
  }

  #main-div {
    min-height: calc(100vh - 300px);
  }

  body::-webkit-scrollbar {
    /* width: 10px; */
  }

  body {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .hint-message {
    z-index: 9999999 !important;
    background-color: #fff !important;
    border: 0 !important;
    box-shadow: 0 0px 10px rgba(0, 0, 0, 0.3) !important;
    border-radius: 8px !important;
  }

  .el-message__content {
    color: #666 !important;
    margin-left: 10px !important;
  }

  .el-dropdown-menu {
    width: 232px;
  }
</style>
